import "./App.css";
import LayoutPage from "./pages/LayoutPage";

function App() {
  return (
    <>
      <LayoutPage />
    </>
  );
}

export default App;
